module.exports = __webpack_public_path__ + "img/抽獎紀錄.4607b62a.png";